import { useContext, useState } from "react";
import { motion,  AnimatePresence } from "framer-motion";
import { dataContext } from "../../../context/context";
import './webdesign.css';
import logo3d from "../../../assets/images/logo.png";
import {useMediaQuery} from "react-responsive";



function Webdesign() {

    const {data, isLocal, setModal} = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://fnxstudio.ru" + urlPrefix;

    const section = data.sectionsdata.find(s => s.nick === 'webdesign');
    const paragraphs = section ? section.paragraphsdata : [];

    const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });
    const [selected, setSelected] = useState(null);

    return (

        <>
        <motion.section
            id="webdesign"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            onAnimationComplete={() => {
                setShowItems(true);
            }}
        >


                {
                    paragraphs.slice(0, 1).map((par) => (

                        <>

                        <div className="inner_block">

                            <h2><img src={logo3d} alt={section.title} />{section.title}</h2>

                            <h3>{par.title}</h3>
                            {par.text}

                            <button onClick={() => setModal(true)}>Заказать интернет-сайт</button>

                        </div>

                            { par.galerydata.length > 0  && (

                                <div className="galery">
                                <div className="galery_inner">

                                    {
                                        par.galerydata.map((gal, index) => (


                                            <motion.div
                                                key={index}
                                                layoutId={`image-${index}`}
                                                initial={{ opacity: 0, y: 10, scale: 0.5, rotateY: -20, rotateZ: 10 }}
                                                animate={ showItems ? { opacity: 1, y: 0, scale: 1, rotateY: (isMobile ? 0 : -10), rotateZ:  (isMobile ? 0 : 5) } : {}}
                                                transition={{ delay: index * 0.3, duration: 0.3 }}
                                                className="galery_item"
                                                onClick={() => setSelected(gal.image)}
                                            >
                                                <div className="img" style={{ backgroundImage: `url(${urlPrefix + gal.image})` }}></div>

                                                {
                                                    gal.text.map((line, index2) => (
                                                        <span key={index2}>{line}<br /></span>
                                                    ))
                                                }

                                            </motion.div>

                                        ))
                                    }
                                </div>
                                </div>

                            )}

                        </>

                    ))
                }


        </motion.section>

    <AnimatePresence>
        { (selected !== null) && (

            <>
            <motion.div key={`background-${selected}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 1 }} exit={{ opacity: 0 }}  className="background_modal" onClick={() => setSelected(null)}></motion.div>

            <motion.div
                layoutId={`image-${selected}`}
                key={`modal-${selected}`}  initial={{ x: "-50%", y: "-200%", opacity: 0 }} animate={{ x: "-50%", y: "-50%", opacity: 1 }}  exit={{ x: "-50%", y: "200%", opacity: 0 }}
                transition={{
                    type: "spring",
                    stiffness: 250,
                    damping: 25
                }}
                onClick={() => setSelected(null)}
                className="biggalery_item"
            >

                <img src={urlPrefix + selected} alt="" />

            </motion.div>
            </>

        )}
    </AnimatePresence>

    </>

    )

}

export default Webdesign;